module.exports = __webpack_public_path__ + "img/home_2@2x.10fd5713.jpg";